import { TableColumns, TableRow } from '@toggle/toggle';

import { VisualizationTable } from '../use-visualization-store/useVisualizationStore';
import { htmlNodes } from './htmlNodes';

export const generateTableTag = (tableData: VisualizationTable): string => {
  if (!tableData.data || !tableData.columnsMeta) {
    return '';
  }

  const headerRow = htmlNodes.tr(
    `${tableData.columnsMeta
      .map((col: TableColumns) => htmlNodes.th(col.title))
      .join('')}`
  );

  const bodyRows = tableData.data
    .map((row: TableRow) => {
      const cells = tableData.columnsMeta
        .map((col: TableColumns) => {
          return htmlNodes.td(row[col.id]?.value || '');
        })
        .join('');
      return htmlNodes.tr(cells);
    })
    .join('');

  return htmlNodes.table(`${headerRow}${bodyRows}`);
};
